<template lang="pug">

  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-md-6
        .ibox.float-e-margins
          .ibox-title
            h2 {{ userId ? 'Edit' : 'Create' }} User

          .ibox-content
            .row
              .col-xs-12
                form(role="form" v-on:submit.prevent="onSubmit")
                  .form-group
                    label Name
                    input.form-control(type="text" placeholder="Name" v-model="user.name")
                  .form-group(v-if="userId == null")
                    label Username
                    input.form-control(type="text" placeholder="Username" v-model="user.username")
                  .form-group(v-if="userId == null")
                    label Password
                    input.form-control(type="password" placeholder="Password" v-model="user.password")
                  .form-group(v-if="userId == null")
                    label Re-Password
                    input.form-control(type="password" placeholder="Re-Password" v-model="user.repassword")
                  .form-group
                    label Role
                    select.form-control(v-model="user.role_id")
                      option(v-for="role in roles" :value="role.id") {{ role.name }}
                  div
                    button.btn.btn-sm.btn-primary.m-t-n-xs(type="submit")
                      strong(v-if="userId") Save
                      strong(v-else) Create
                    | &nbsp;&nbsp;&nbsp;
                    button.btn.btn-sm.btn-white.m-t-n-xs(@click="$router.go(-1)")
                      strong Cancel

</template>

<script>
  import axios from 'axios'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'

  export default {
    data () {
      return {
        userId: this.$route.params.id,
        roles: [],
        user: {}
      }
    },
    created () {
      this.fetchRole()
    },
    mounted () {
      if (this.userId) this.fetchUser()
      else {
        this.user = {
          id: null,
          name: null,
          username: null,
          password: null,
          repassword: null,
          role_id: '2',
          create_by_id: this.$ls.get('user').id
        }
      }
    },
    methods: {
      fetchRole () {
        axios.get('user/role').then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.roles = res.data.data
              console.log(this.roles)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      fetchUser () {
        axios.get(`user/id/${this.userId}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.user = res.data.data
              this.user.update_by_id = this.$ls.get('user').id
              console.log(this.user)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      onSubmit () {
        if (this.userId) {
          // Edit
          axios.put('user', this.user).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success(`Success to edit ${this.user.username}`, { timeOut: 2000 })
                this.$router.push('/users')
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                toastr.error('Edit Fail', res.data.message, { timeOut: 2000 })
                this.$router.push('/users')
            }
          })
        } else {
          // Create
          axios.post('user', this.user).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success(`Success to create ${this.user.username}`, { timeOut: 2000 })
                this.$router.push('/users')
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                toastr.error('Create Fail', res.data.message, { timeOut: 2000 })
                this.$router.push('/users')
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?784b4d97